import React from "react";
import { useOdooLiveChatIdentify } from "hooks/use-odoo-live-chat-identify/use-odoo-live-chat-identify";

export const OdooLiveChatIdentify: React.FC = () => {
  useOdooLiveChatIdentify();
  return null;
};
